<template>
  <div>
    <h2
      v-if="subject.dateFrom"
      class="bordered-box-header"
    >Szczegóły wybranego tematu ({{subject.dateFrom | date}} - {{subject.dateTo | date}})</h2>
    <h2 v-else class="bordered-box-header">Szczegóły wybranego tematu</h2>

    <b-container fluid class="bordered-box">
      <b-row class="justify-content-center" v-if="loading">
        <b-spinner big label="Loading..."></b-spinner>
      </b-row>
      <b-row v-else-if="subject">
        <b-col cols="12">
          <h3>
            {{subject.title}}
            <span class="text-lowercase font-italic">({{subject.domain}})</span>
          </h3>
          <p>{{subject.description}}</p>
        </b-col>
        <b-col cols="12">
          <button class="btn btn-primary edit-item" @click="showEditSubjectModal">Edytuj</button>
          <button
            v-if="!subject.locked"
            class="btn btn-primary edit-item"
            @click="showAddWordModal"
          >Dodaj wyraz</button>
          <button
            v-if="!subject.locked"
            class="btn btn-danger delete-item"
            @click="removeSubjectModal"
          >Usuń</button>
          <hr />
        </b-col>
        <b-col cols="12">
          <b-row no-gutters>
            <b-col xl="4" md="6" cols="12">
              <h2
                v-if="subject.dates.Day_1"
                class="bordered-box-header"
              >Dzień 1 ({{subject.dates.Day_1 | date}})</h2>
              <h2 v-else class="bordered-box-header">Dzień 1</h2>
              <div v-for="word in subject.words.Day_1" :key="word.id" class="word-item">
                <wordDetails
                  :word="word"
                  :canDelete="!subject.locked"
                  @onDelete="showRemoveWordModal(word, 1, 'Day_1')"
                />
              </div>
            </b-col>

            <b-col xl="4" md="6" cols="12">
              <h2
                v-if="subject.dates.Day_2"
                class="bordered-box-header"
              >Dzień 2 ({{subject.dates.Day_2 | date}})</h2>
              <h2 v-else class="bordered-box-header">Dzień 2</h2>

              <div v-for="word in subject.words.Day_2" :key="word.id" class="word-item">
                <wordDetails
                  :word="word"
                  :canDelete="!subject.locked"
                  @onDelete="showRemoveWordModal(word, 2, 'Day_2')"
                />
              </div>
            </b-col>

            <b-col xl="4" md="6" cols="12">
              <h2
                v-if="subject.dates.Day_3"
                class="bordered-box-header"
              >Dzień 3 ({{subject.dates.Day_3 | date}})</h2>
              <h2 v-else class="bordered-box-header">Dzień 3</h2>
              <div v-for="word in subject.words.Day_3" :key="word.id" class="word-item">
                <wordDetails
                  :word="word"
                  :canDelete="!subject.locked"
                  @onDelete="showRemoveWordModal(word, 3, 'Day_3')"
                />
              </div>
            </b-col>

            <b-col xl="4" md="6" cols="12">
              <h2
                v-if="subject.dates.Day_4"
                class="bordered-box-header"
              >Dzień 4 ({{subject.dates.Day_4 | date}})</h2>
              <h2 v-else class="bordered-box-header">Dzień 4</h2>
              <div v-for="word in subject.words.Day_4" :key="word.id" class="word-item">
                <wordDetails
                  :word="word"
                  :canDelete="!subject.locked"
                  @onDelete="showRemoveWordModal(word, 4, 'Day_4')"
                />
              </div>
            </b-col>

            <b-col xl="4" md="6" cols="12">
              <h2
                v-if="subject.dates.Day_5"
                class="bordered-box-header"
              >Dzień 5 ({{subject.dates.Day_5 | date}})</h2>
              <h2 v-else class="bordered-box-header">Dzień 5</h2>
              <div v-for="word in subject.words.Day_5" :key="word.id" class="word-item">
                <wordDetails
                  :word="word"
                  :canDelete="!subject.locked"
                  @onDelete="showRemoveWordModal(word, 5, 'Day_5')"
                />
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <editSubjectModal ref="editSubjectModal" @save="onEditSubject" :subject="subject" />
    <addWordModal ref="addWordModal" @save="onAddWord" />
  </div>
</template>
<script>
import { axios, eventBus } from "@/_infrastructure";
import editSubjectModal from "./DetailsCourseAddEditSubjectModal";
import addWordModal from "./DetailsCourseAssignWordModal";
import wordDetails from "./DetailsCourseWordItem";
import moment from "moment";

export default {
  data() {
    return {
      loading: false,
      subject: null
    };
  },
  props: ["id"],
  components: {
    editSubjectModal,
    addWordModal,
    wordDetails
  },
  mounted() {
    if (this.id) {
      this.refresh();
    }
  },
  methods: {
    refresh() {
      this.loading = true;

      axios
        .get("/subjects/details", {
          params: {
            id: this.id
          }
        })
        .then(response => {
          this.subject = response.data;
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          this.loading = false;
        });
    },

    showEditSubjectModal() {
      this.$refs.editSubjectModal.show();
    },

    onEditSubject(r) {
      let loader = this.$loading.show({
        container: this.$refs.mainContainer
      });

      r.id = this.id;

      axios
        .put("/subjects", r)
        .then(response => {
          var result = response.data;

          this.subject.title = result.title;
          this.subject.domain = result.domain;
          this.subject.description = result.description;

          eventBus.$emit("notify-success", "Zapisano poprawnie.");
          this.$emit("changed", response.data);
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          loader.hide();
        });
    },
    removeSubjectModal() {
      this.$bvModal
        .msgBoxConfirm(
          "Czy na pewno chcesz usunąć z wybranego kursu wskazany temat?"
        )
        .then(value => {
          if (value) {
            this.onDeleteSubject();
          }
        });
    },
    onDeleteSubject() {
      let loader = this.$loading.show({
        container: this.$refs.mainContainer
      });

      axios
        .delete("/subjects", {
          params: {
            id: this.id
          }
        })
        .then(() => {
          eventBus.$emit("notify-success", "Temat usunięto poprawnie.");
          this.$emit("deleted");
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          loader.hide();
        });
    },
    showAddWordModal() {
      this.$refs.addWordModal.show();
    },
    onAddWord(r) {
      let loader = this.$loading.show({
        container: this.$refs.mainContainer
      });

      r.subjectId = this.id;

      axios
        .post("/subjects/word", r)
        .then(response => {
          var result = response.data;
          var key = "Day_" + r.day;

          if (!this.subject.words[key]) {
            this.subject.words[key] = [];
          }

          this.subject.words[key].push(result);
          eventBus.$emit("notify-success", "Zapisano poprawnie.");
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          loader.hide();
        });
    },
    showRemoveWordModal(item, day, dayKey) {
      this.$bvModal
        .msgBoxConfirm("Czy na pewno chcesz usunąć wskazany wyraz?")
        .then(value => {
          if (value) {
            this.onRemoveWord(item, day, dayKey);
          }
        });
    },
    onRemoveWord(item, day, dayKey) {
      let loader = this.$loading.show({
        container: this.$refs.mainContainer
      });

      axios
        .delete("/subjects/word", {
          params: {
            subjectId: this.id,
            wordId: item.id,
            day: day
          }
        })
        .then(() => {
          eventBus.$emit(
            "notify-success",
            "Poprawnie usunięto wyraz z tematu."
          );
          this.subject.words[dayKey] = this.subject.words[dayKey].filter(
            d => d != item
          );
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          loader.hide();
        });
    },
    moment: function() {
      return moment();
    }
  },
  filters: {
    date(date) {
      return date ? moment(date).format("YYYY-MM-DD") : "-";
    }
  }
};
</script>
<style lang="scss" scoped>
.word-item {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 1px;
  padding: 5px;
  margin-bottom: -1px;

  &:hover {
    background: rgba(0, 0, 0, 0.03);
  }
}
.item {
  border: 1px solid rgba(0, 0, 0, 0.125);
  background: rgba(0, 0, 0, 0.03);
  border-radius: 1px;
  padding: 5px;
  margin-bottom: -1px;
  cursor: pointer;
}
.active-item {
  cursor: move;
}
.selected-item {
  background: rgba(0, 255, 0, 0.125);
}
.add-item,
.edit-item,
.delete-item {
  margin: 0px 10px 10px 0px;
}

h2.bordered-box-header {
  margin-top: 20px;
  padding: 10px;
  margin-bottom: 0px;
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.bordered-box {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 10px;
}
</style>
